/* eslint-env browser */

import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

let currentUser;

try {
  currentUser = JSON.parse(localStorage.getItem('currentUser')) || null;
} catch (err) {
  currentUser = null;
}

export default new Vuex.Store({
  modules: {},
  state: {
    currentUser
  },
  getters: {
    currentUser(state) {
      return state.currentUser;
    },
    isAdmin(state) {
      return state.currentUser && state.currentUser.isAdmin;
    }
  },
  mutations: {
    setCurrentUser(state, currentUser = null) {
      state.currentUser = currentUser;
      localStorage.setItem('currentUser', JSON.stringify(currentUser));
    }
  }
});
